import { z } from 'zod';

import {
    EMAIL_IN_USE,
    type EmailInUseDetails,
    emailInUseDetailsSchema,
} from '@nesso/client-contracts/client.errors';

import { ApiError } from '@/shared/api/http-client';

export type EmailInUseError = EmailInUseDetails;

const emailInUseBodySchema = z.object({ details: emailInUseDetailsSchema });

// A refusal that names no holder has nothing to render beside the field, so it resolves to null
// and surfaces as the generic failure.
export function resolveEmailInUseError(error: unknown): EmailInUseError | null {
    if (!(error instanceof ApiError) || error.status !== 409 || error.message !== EMAIL_IN_USE) {
        return null;
    }

    const parsed = emailInUseBodySchema.safeParse(error.response);
    return parsed.success ? parsed.data.details : null;
}
